import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toast = () => {
    return <ToastContainer />;
};
const showToast = (type = "default", message) => {
    const toastSytle = {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
    };
    switch (type) {
        case "success":
            toast.success(message, toastSytle);
            break;
        case "error":
            toast.error(message, toastSytle);
            break;
        case "warning":
            toast.warn(message, toastSytle);
            break;
        default:
            toast(message);
            break;
    }
};

export { Toast, showToast };
